export const site = {
    name: 'VLM Asszisztens',
    description: 'VLM AI asszisztens'
}

export const titles = {
    home: 'VLM Asszisztens',
    notFound: 'Nincs találat',
    serverError: 'Szerverhiba'
}
